import type { Merchant } from '@/types/portal';

/**
 * Merchants and till numbers a Buy Goods payment can settle to. The favourites
 * ship pinned so the Buy Goods screen opens with the merchants this agency pays
 * most often.
 */
export const merchants: Merchant[] = [
  {
    id: 'merchant-fruits-world',
    name: 'Fruits World',
    mark: 'FW',
    till: '4280186',
    category: 'Groceries',
    favourite: true,
  },
  {
    id: 'merchant-naivas',
    name: 'Naivas Supermarket',
    mark: 'NV',
    till: '4002001',
    category: 'Groceries',
    favourite: true,
  },
  {
    id: 'merchant-quickmart',
    name: 'Quickmart',
    mark: 'QM',
    till: '4003002',
    category: 'Groceries',
    favourite: true,
  },
  {
    id: 'merchant-java-house',
    name: 'Java House',
    mark: 'JH',
    till: '4005004',
    category: 'Food & Drink',
    favourite: true,
  },
  {
    id: 'merchant-carrefour',
    name: 'Carrefour Kenya',
    mark: 'CF',
    till: '4004003',
    category: 'Groceries',
    favourite: false,
  },
  {
    id: 'merchant-artcaffe',
    name: 'Artcaffe',
    mark: 'AC',
    till: '4006005',
    category: 'Food & Drink',
    favourite: false,
  },
  {
    id: 'merchant-chandarana',
    name: 'Chandarana Foodplus',
    mark: 'CH',
    till: '4007006',
    category: 'Groceries',
    favourite: false,
  },
  {
    id: 'merchant-shell',
    name: 'Shell Kenya',
    mark: 'SH',
    till: '4008007',
    category: 'Fuel',
    favourite: false,
  },
  {
    id: 'merchant-total',
    name: 'TotalEnergies',
    mark: 'TE',
    till: '4009008',
    category: 'Fuel',
    favourite: false,
  },
];